import { createGlobalStyle } from 'styled-components';

const pageStyle = createGlobalStyle`
  .lst-kix_dqljyk4kmem1-2 > li:before {
    content: "\\0025a0   "
  }

  .lst-kix_dqljyk4kmem1-3 > li:before {
    content: "\\0025cf   "
  }

  ul.lst-kix_dqljyk4kmem1-0 {
    list-style-type: none
  }

  .lst-kix_dqljyk4kmem1-6 > li:before {
    content: "\\0025cf   "
  }

  .lst-kix_dqljyk4kmem1-4 > li:before {
    content: "\\0025cb   "
  }

  li.li-bullet-0:before {
    margin-left: -18pt;
    white-space: nowrap;
    display: inline-block;
    min-width: 18pt
  }

  .lst-kix_dqljyk4kmem1-5 > li:before {
    content: "\\0025a0   "
  }

  ul.lst-kix_dqljyk4kmem1-8 {
    list-style-type: none
  }

  ul.lst-kix_dqljyk4kmem1-7 {
    list-style-type: none
  }

  ul.lst-kix_dqljyk4kmem1-6 {
    list-style-type: none
  }

  ul.lst-kix_dqljyk4kmem1-5 {
    list-style-type: none
  }

  ul.lst-kix_dqljyk4kmem1-4 {
    list-style-type: none
  }

  ul.lst-kix_dqljyk4kmem1-3 {
    list-style-type: none
  }

  ul.lst-kix_dqljyk4kmem1-2 {
    list-style-type: none
  }

  .lst-kix_dqljyk4kmem1-7 > li:before {
    content: "\\0025cb   "
  }

  ul.lst-kix_dqljyk4kmem1-1 {
    list-style-type: none
  }

  .lst-kix_dqljyk4kmem1-0 > li:before {
    content: "\\0025cf   "
  }

  .lst-kix_dqljyk4kmem1-8 > li:before {
    content: "\\0025a0   "
  }

  .lst-kix_dqljyk4kmem1-1 > li:before {
    content: "\\0025cb   "
  }

  ol {
    margin: 0;
    padding: 0
  }

  table td, table th {
    padding: 0
  }

  .c6 {
    border-right-style: solid;
    padding: 8pt 12pt 8pt 0pt;
    border-bottom-color: #000000;
    border-top-width: 0pt;
    border-right-width: 0pt;
    border-left-color: #000000;
    vertical-align: top;
    border-right-color: #000000;
    border-left-width: 0pt;
    border-top-style: solid;
    border-left-style: solid;
    border-bottom-width: 0pt;
    width: 137.6pt;
    border-top-color: #000000;
    border-bottom-style: solid
  }

  .c8 {
    border-right-style: solid;
    padding: 8pt 12pt 8pt 0pt;
    border-bottom-color: #000000;
    border-top-width: 0pt;
    border-right-width: 0pt;
    border-left-color: #000000;
    vertical-align: top;
    border-right-color: #000000;
    border-left-width: 0pt;
    border-top-style: solid;
    border-left-style: solid;
    border-bottom-width: 0pt;
    width: 330.4pt;
    border-top-color: #000000;
    border-bottom-style: solid
  }

  .c16 {
    margin-left: 36pt;
    padding-top: 12pt;
    padding-left: 0pt;
    padding-bottom: 12pt;
    line-height: 1.15;
    orphans: 2;
    widows: 2;
    text-align: left
  }

  .c0 {
    color: #000000;
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 11pt;
    font-family: "Arial";
    font-style: normal
  }

  .c15 {
    padding-top: 12pt;
    padding-bottom: 15pt;
    line-height: 1.15;
    orphans: 2;
    widows: 2;
    text-align: center
  }

  .c13 {
    padding-top: 12pt;
    padding-bottom: 15pt;
    line-height: 1.15;
    orphans: 2;
    widows: 2;
    text-align: left
  }

  .c2 {
    padding-top: 0pt;
    padding-bottom: 0pt;
    line-height: 1.15;
    orphans: 2;
    widows: 2;
    text-align: left
  }

  .c9 {
    padding-top: 0pt;
    padding-bottom: 8pt;
    line-height: 1.15;
    orphans: 2;
    widows: 2;
    text-align: left
  }

  .c5 {
    color: #000000;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 18pt;
    font-family: "Arial";
    font-style: normal
  }

  .c14 {
    border-spacing: 0;
    border-collapse: collapse;
    margin-right: auto
  }

  .c19 {
    background-color: #ffffff;
    max-width: 468pt;
    padding: 72pt 72pt 72pt 72pt
  }

  .c10 {
    padding: 0;
    margin: 0
  }

  .c11 {
    font-size: 18pt
  }

  .c18 {
    height: 58.5pt
  }

  .c1 {
    font-size: 9pt
  }

  .c3 {
    font-weight: 700
  }

  .c7 {
    height: 25.5pt
  }

  .c4 {
    height: 11pt
  }

  .c17 {
    height: 69pt
  }

  .c12 {
    height: 47.2pt
  }

  .title {
    padding-top: 0pt;
    color: #000000;
    font-size: 26pt;
    padding-bottom: 3pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
  }

  .subtitle {
    padding-top: 0pt;
    color: #666666;
    font-size: 15pt;
    padding-bottom: 16pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
  }

  li {
    color: #000000;
    font-size: 11pt;
    font-family: "Arial"
  }

  p {
    margin: 0;
    color: #000000;
    font-size: 11pt;
    font-family: "Arial"
  }

  h1 {
    padding-top: 20pt;
    color: #000000;
    font-size: 20pt;
    padding-bottom: 6pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
  }

  h2 {
    padding-top: 18pt;
    color: #000000;
    font-size: 16pt;
    padding-bottom: 6pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
  }

  h3 {
    padding-top: 16pt;
    color: #434343;
    font-size: 14pt;
    padding-bottom: 4pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
  }

  h4 {
    padding-top: 14pt;
    color: #666666;
    font-size: 12pt;
    padding-bottom: 4pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
  }

  h5 {
    padding-top: 12pt;
    color: #666666;
    font-size: 11pt;
    padding-bottom: 4pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
  }

  h6 {
    padding-top: 12pt;
    color: #666666;
    font-size: 11pt;
    padding-bottom: 4pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    font-style: italic;
    orphans: 2;
    widows: 2;
    text-align: left
  }
`;

export default pageStyle;
